import { Select } from 'components/form/Select';
import React, { useCallback } from 'react';
import { useRecoilState } from 'recoil';
import { lookupState } from 'state/atoms';

const PartsDropdown = ({ parts }) => {
  const [currentLookupState, setLookupState] = useRecoilState(lookupState);

  const onOptionSelected = useCallback(
    (event) => {
      const selectedValue = event.currentTarget.value;
      const selectedOther = selectedValue === 'other';
      const selectedResult = selectedOther
        ? null
        : currentLookupState.lookupResults[selectedValue];

      // Make sure to setup the state correctly when the user
      // returns to "Select" option
      if (!selectedValue) {
        setLookupState({
          ...currentLookupState,
          reviewRequested: false,
          selectedResult: null,
          presentPartSearch: false,
          searchedPartNumber: '',
        });
        return;
      }

      setLookupState({
        ...currentLookupState,
        selectedResult,
        reviewRequested: false,
        reviewDescription: {
          touched: false,
          value: '',
        },
        incorrectPartNumber:
          selectedOther && currentLookupState.lookupResults.length > 1,
        presentPartSearch: selectedOther,
      });
    },
    [currentLookupState, setLookupState]
  );

  return (
    <Select onChange={onOptionSelected}>
      <option value="">Select</option>
      {parts.map((part, index) => (
        <option key={`${part.serialNumber}-${index}`} value={index}>
          {part.product.partNumber}
        </option>
      ))}
      <option value="other">Other</option>
    </Select>
  );
};

export default PartsDropdown;
